<script setup>
    import { computed } from "vue";

    const props = defineProps({
        validationResponseDetail: {
            type: Object,
            required: true
        }
    });

    const isMatch = computed(() => {
        return props.validationResponseDetail.isMatch;
    });
    const explanation = computed(() => {
        return props.validationResponseDetail.explanation;
    });

    const iconName = computed(() => {
        return isMatch.value ? "check-circle" : "exclamation-circle";
    });
    const iconClass = computed(() => {
        return {
            "text-success": isMatch.value,
            "text-danger": !isMatch.value
        };
    });
</script>

<template>
    <div>
        <div class="mb-3 fw-bold">
            <div class="d-flex align-items-center">
                <pc-bs-icon
                    v-bind:name="iconName"
                    class="me-2"
                    v-bind:class="iconClass" />
                <div v-if="isMatch">Yes, the upload is valid.</div>
                <div v-else>No, the upload is not valid.</div>
            </div>
        </div>
        <div>{{ explanation }}</div>
    </div>
</template>
